import React from 'react';

const Testimonial = () => {
  return (
    <section className="px-12 lg:px-20 py-16 sm:py-20 lg:py-24 bg-[#FAF8F6]">
      <div className="max-w-4xl mx-auto">
        {/* Featured Testimonial */}
        <div className="text-center space-y-8 sm:space-y-10">
          {/* Quote */}
          <blockquote className="text-xl sm:text-2xl lg:text-3xl font-light text-black italic leading-relaxed tracking-wide">
            "I love how my makeup was still intact after more than 7 hours. I really wanted something natural and Laura delivered perfectly. I felt like a princess, and working with her was an absolute dream."
          </blockquote>
          
          {/* Divider */}
          <div className="w-12 h-px bg-black/20 mx-auto"></div>
          
          {/* Client Name */}
          <p className="text-[8px] sm:text-[9px] tracking-[2.5px] uppercase text-black/50 font-light">
            Susana
          </p>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
